var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.ExpandImage}},[_c('img',{style:({'max-height': _vm.ImageMaxHeight != null ? _vm.ImageMaxHeight + 'px' : 'auto'}),attrs:{"src":_vm.ImageSource}})])}
var staticRenderFns = []

export { render, staticRenderFns }